import React from 'react';
import styled from 'styled-components';

interface StyleProps {
  size: number;
  color: string;
}

interface Props {
  color?: string;
  size?: number;
  title: string;
}

const H4 = ({ color = '#000', size = 16, title }: Props) => {
  return (
    <H4Style color={color} size={size}>
      {title}
    </H4Style>
  );
};

export default H4;

/* styles */
const H4Style = styled.h4<StyleProps>`
  font-size: ${({ size }) => `${size}px`};
  color: ${({ color }) => color};
`;
